import * as React from "react";

function SvgFreeTimePainting(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 574 552"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <g transform="translate(-129.761 -102.56)">
        <g id="free_time_painting_svg__painting">
          <g transform="matrix(-1.49296 1.38396 -1.15017 -1.24075 1369.572 -112.532)">
            <path
              d="M509.774 141.27c33.811.928 74.564 4.747 92.293 12.83-5.796 11.472-6.5 28.533 1.433 41.161-20.257 12.122-63.473 16.893-93.726 16.247-122.848-2.622-195.4-18.169-195.4-37.552s72.565-36.059 195.4-32.686z"
              fill="#fc837f"
            />
            <clipPath id="free_time_painting_svg___clip1">
              <path d="M509.774 141.27c33.811.928 74.564 4.747 92.293 12.83-5.796 11.472-6.5 28.533 1.433 41.161-20.257 12.122-63.473 16.893-93.726 16.247-122.848-2.622-195.4-18.169-195.4-37.552s72.565-36.059 195.4-32.686z" />
            </clipPath>
            <g clipPath="url(#free_time_painting_svg___clip1)">
              <path
                d="M509.774 141.27c33.811.928 74.564 4.747 92.293 12.83-5.796 11.472-6.5 28.533 1.433 41.161-20.257 12.122-63.473 16.893-93.726 16.247-122.848-2.622-195.4-18.169-195.4-37.552s72.565-36.059 195.4-32.686z"
                fill="#fe8d8a"
                transform="matrix(1 0 0 1 -1.98 10.686)"
              />
              <g transform="matrix(-.36024 -.40183 .33394 -.43347 533.752 499.696)">
                <circle cx={248.325} cy={522.11} r={61.333} fill="#c45b5b" />
                <clipPath id="free_time_painting_svg___clip2">
                  <circle cx={248.325} cy={522.11} r={61.333} />
                </clipPath>
                <g clipPath="url(#free_time_painting_svg___clip2)">
                  <path
                    d="M589.819 202.236c-25.051 6.314-28.253-58.169-7.944-54.064 8.15 1.648 15.115 3.613 20.192 5.928-5.796 11.472 5.128 26.191 13.061 38.818-5.951 3.562-14.888 6.691-25.309 9.318z"
                    fill="#ca6666"
                    transform="matrix(-1.49296 1.38396 -1.15017 -1.24075 1362.27 -134.694)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g transform="matrix(1.03443 .48914 -.5241 1.10836 319.836 -140.338)">
            <path
              d="M182.742 491.383c32.379 0 58.667 27.184 58.667 60.666 0 33.483-33.194 52.802-61.398 67.494-8.908 4.641-16.007 9.539-22.499 27.623-33.268-12.788-47.183-76.465-40.263-103.991 8.528-33.929 33.114-51.792 65.493-51.792z"
              fill="#feb4b2"
            />
            <clipPath id="free_time_painting_svg___clip3">
              <path d="M182.742 491.383c32.379 0 58.667 27.184 58.667 60.666 0 33.483-33.194 52.802-61.398 67.494-8.908 4.641-16.007 9.539-22.499 27.623-33.268-12.788-47.183-76.465-40.263-103.991 8.528-33.929 33.114-51.792 65.493-51.792z" />
            </clipPath>
            <g clipPath="url(#free_time_painting_svg___clip3)">
              <path
                d="M147.064 671.341c-5.72-12.619 4.224-35.02 22-40.5 31.084-9.584 115.006-34.308 107.5-119 74.059 100.346 33.775 149.82-129.5 159.5z"
                fill="#fea9a6"
                transform="matrix(.79006 -.34867 .37359 .73736 -203.803 211.895)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgFreeTimePainting;
